// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__tcPJg","containerItemsCenter":"Skeleton_containerItemsCenter__xApHO"};